import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import confetti from 'canvas-confetti';
import { Button } from './ui/button';

import { getBackendUrl } from '../utils/getBackendUrl';
const API = `${getBackendUrl()}/api`;

export const BadgeCelebration = ({ user }) => {
  const [badges, setBadges] = useState([]);
  const firedRef = useRef(false);

  useEffect(() => {
    if (!['employee', 'supervisor'].includes(user.role)) return;
    const timer = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/badges/my/unseen`);
        if (r.data.length > 0) setBadges(r.data);
      } catch (e) { /* ignore */ }
    }, 3500); // let the welcome splash finish first
    return () => clearTimeout(timer);
  }, [user]);

  useEffect(() => {
    if (badges.length === 0 || firedRef.current) return;
    firedRef.current = true;
    const end = Date.now() + 2500;
    const frame = () => {
      confetti({ particleCount: 5, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, zIndex: 160 });
      confetti({ particleCount: 5, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, zIndex: 160 });
      if (Date.now() < end) requestAnimationFrame(frame);
    };
    confetti({ particleCount: 120, spread: 100, origin: { y: 0.6 }, zIndex: 160 });
    frame();
  }, [badges]);

  const dismiss = async () => {
    setBadges([]);
    try { await axios.post(`${API}/badges/my/mark-seen`); } catch (e) { /* ignore */ }
  };

  if (badges.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center p-6" style={{ backgroundColor: 'rgba(2, 6, 23, 0.75)' }} data-testid="badge-celebration">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
        <p className="text-4xl mb-1">🎉</p>
        <h2 className="text-2xl font-extrabold text-gray-900">
          You earned {badges.length === 1 ? 'a new badge!' : `${badges.length} new badges!`}
        </h2>
        <div className="my-4 space-y-2 max-h-56 overflow-y-auto">
          {badges.map((b) => (
            <div key={b.id} className="flex items-center gap-3 p-3 rounded-xl bg-amber-50 border border-amber-200" data-testid={`new-badge-${b.slug}`}>
              <span className="text-3xl">{b.icon}</span>
              <div className="text-left">
                <p className="font-bold text-gray-900">{b.label}</p>
                {b.desc && <p className="text-xs text-gray-600">{b.desc}</p>}
              </div>
            </div>
          ))}
        </div>
        <Button onClick={dismiss} className="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold min-h-[44px]" data-testid="badge-celebration-dismiss">
          Awesome!
        </Button>
      </div>
    </div>
  );
};

export default BadgeCelebration;
